export default __webpack_public_path__ + "static/NataliaCichocka-Stępień-b282ba7be82c29ee46a7236088aada69.png";